module.exports = __webpack_public_path__ + "static/illustration-ecosystem-l1-0f94534060d8eef3cc2dbda4fa0b8fec.webp";